import { render, staticRenderFns } from "./ConversionSelectMenu.vue?vue&type=template&id=9b46df70&scoped=true"
import script from "./ConversionSelectMenu.vue?vue&type=script&lang=ts"
export * from "./ConversionSelectMenu.vue?vue&type=script&lang=ts"
import style0 from "./ConversionSelectMenu.vue?vue&type=style&index=0&id=9b46df70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b46df70",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/users/conversions-select-menu.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fusers%2FConversionSelectMenu.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports